import { useUser } from "../contexts/UserContext";
import { USER_TYPES } from "../types/userType";

const useIsSuperAdmin = () => {
  const { userType } = useUser();
  
  // userType can be a string (single) or array (multiple roles)
  if (!userType) return false;
  if (Array.isArray(userType)) {
    return userType.includes(USER_TYPES.SUPER_ADMIN);
  }
  return userType === USER_TYPES.SUPER_ADMIN;
};

export default useIsSuperAdmin; 